<template>
  <a-collapse
    v-model:activeKey="thisActiveKey"
    expand-icon-position="right"
    :bordered="false"
  >
    <a-collapse-panel key="performance-review">
      <div
        class="content"
        v-html="performanceObjectiveSelfReview || $t(`okr.nothing`)"
      />
      <template #header>
        <a-space :style="{ marginLeft: '24px' }">
          <IconFont
            type="iconpingjia"
            :style="{ fontSize: '18px' }"
          />
          <span :style="{ fontWeight: 'bold' }">
            {{ $t('okr.list.performanceReview') }}
          </span>
        </a-space>
      </template>
    </a-collapse-panel>
  </a-collapse>
</template>
<script>
import { ref } from 'vue'
export default {
  props: {
    performanceObjectiveSelfReview: {
      type: String,
      default: ''
    },
    activeKey: {
      type: Array,
      default: () => []
    }
  },
  setup (props) {
    const thisActiveKey = ref([...props.activeKey])
    return {
      thisActiveKey
    }
  }
}
</script>
<style lang="less" scoped>
.content {
  padding: 0 10px 0 36px;
}

:deep(.ant-collapse-content) > .ant-collapse-content-box {
  padding: 4px 16px 16px 16px !important;
}

:deep(.ant-collapse-header) {
  padding: 12px 2px !important;
  display: flex;
  align-items: center;

  .ant-collapse-arrow {
    margin-left: 8px;
    position: static !important;
    order: 2;
    transform: none !important;
  }
}
</style>
